import Api from "../../api/Api";
import { toast } from "react-toastify";
import {
  ADD_APPLESMS_SUCCESS,
  DELETE_APPLESMS_SUCCESS,
  GET_APPLESMS_SUCCESS,
  UPDATE_APPLESMS_SUCCESS,
} from "./actionTypes";

const getListParams = (params, state) => ({
  page: params.page ?? state?.pagination?.page ?? 1,
  per_page: params.per_page ?? state?.pagination?.per_page ?? 10,
  search: params.search ?? state?.pagination?.search ?? "",
  scope: params.scope ?? "list",
  silent: params.silent ?? false,
});

const getResponseBody = (response) => response?.data ?? response;

const toList = (value) => (Array.isArray(value) ? value : []);

const buildSuccessPayload = (response, { search, scope }) => {
  const data = getResponseBody(response);
  const items = toList(data.data);

  const payload = {
    total: data.total ?? items.length,
    page: data.page ?? 1,
    per_page: data.per_page ?? 10,
    search,
    scope,
  };

  if (scope === "defective") {
    payload.defective = items;
  } else {
    payload.applesms = items;
  }

  return payload;
};

const reloadAppleSMSList = (dispatch, getState, overrides = {}) => {
  const { pagination } = getState().APPLESMS;
  dispatch(
    loadAppleSMS({
      page: pagination?.page ?? 1,
      per_page: pagination?.per_page ?? 10,
      search: pagination?.search ?? "",
      scope: "list",
      silent: true,
      ...overrides,
    })
  );
};

export const loadAppleSMS = (params = {}) => (dispatch, getState) => {
  const listState = getState().APPLESMS;
  const { page, per_page, search, scope, silent } = getListParams(
    params,
    listState
  );

  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;

  const req = Api.get("/applesmsall/get", {
    params: { page, per_page, search, scope },
  });

  const onSuccess = (data) => {
    dispatch({
      payload: buildSuccessPayload(data, { search, scope }),
      type: GET_APPLESMS_SUCCESS,
    });
  };

  if (silent) {
    req.then((response) => onSuccess(response)).catch(() => {});
    return;
  }

  toast.promise(req, {
    pending: "Getting AppleSMS IDs...",
    success: {
      render({ data: response }) {
        onSuccess(response);
        return "Your Data Is Ready";
      },
    },
    error: {
      render() {
        return "An error occurred while getting applesmss IDs";
      },
    },
  });
};

export const addAppleSMS = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/add", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSList(dispatch, getState, { page: 1 });
        return "AppleSMS ID added successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const updateAppleSMS = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/update", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_APPLESMS_SUCCESS,
        });
        reloadAppleSMSList(dispatch, getState);
        return "AppleSMS ID updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your AppleSMS ID";
      },
    },
  });
};

export const deleteAppleSMS = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSList(dispatch, getState);
        return "AppleSMS ID deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your AppleSMS ID";
      },
    },
  });
};

export const soldAppleSMS = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/sold", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSList(dispatch, getState);
        return "AppleSMS ID updated successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while updating your AppleSMS ID";
      },
    },
  });
};

export const importAppleSMS = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  Api.defaults.headers.common["Content-Type"] = "multipart/form-data";
  let req = Api.post("/applesms/import", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSList(dispatch, getState, { page: 1, search: "" });
        return "AppleSMS IDs imported successfully";
      },
    },
    error: {
      render({ data }) {
        return data?.response.data?.message;
      },
    },
  });
};

export const exportAppleSMS = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/export", { number: data.formData.number });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render(response) {
        reloadAppleSMSList(dispatch, getState, { page: 1 });
        window.open(response.data.data, "_blank");
        return "AppleSMS IDs exported successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const exportAppleSMSQr = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/export/qr", {
    number: data.number,
    image: data.image,
    shownote: data.shownote,
    note: data.note,
  });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render(response) {
        reloadAppleSMSList(dispatch, getState, { page: 1 });
        window.open(response.data.data, "_blank");
        return "AppleSMS IDs exported successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const fixApple = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/fix", { accounts: data.formData.accounts });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        reloadAppleSMSList(dispatch, getState, { page: 1 });
        return "Apple IDs fixed successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};

export const deleteAppleDefective = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/applesms/delete/defective", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render() {
        dispatch(
          loadAppleSMS({
            scope: "defective",
            page: getState().APPLESMS.pagination?.page ?? 1,
            per_page: getState().APPLESMS.pagination?.per_page ?? 10,
            search: getState().APPLESMS.pagination?.search ?? "",
            silent: true,
          })
        );
        return "Apple ID deleted successfully";
      },
    },
    error: {
      render() {
        return "An error occurred while deleting your Apple ID";
      },
    },
  });
};
